import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('overview-contact-me-card', []);

interface OverviewContactMeCardController extends angular.IStrictController {
    icon: string;
    description: string;
    reason: ContactReason;
}

module.component('overviewContactMeCard', {
    template: template,
    controller: function(this: OverviewContactMeCardController) {
        this.icon = 'phone-with-message';
        this.description = 'Update your account information and add discounts';
        this.reason = 'add-discounts';
    }
});

export { module };
